import { useState } from "react";
import { faqItems } from "@/mocks/gossip";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr]">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <p className="text-xs font-medium uppercase tracking-widest text-accent-600">Guides</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              吃瓜小课堂 · 常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于更新节奏、热度指数与核实机制，这里都能找到答案。还有想了解的，
              欢迎通过页面底部渠道告诉我们。
            </p>
            <div className="mt-6 flex items-start gap-3 rounded-2xl border border-accent-200 bg-accent-100/50 p-4">
              <i className="ri-information-line mt-0.5 text-lg text-accent-700" aria-hidden="true"></i>
              <p className="text-sm leading-relaxed text-accent-900">
                我们坚持先核实再呈现，尚在发酵的事件会明确标注“进行中”，帮你理性吃瓜、拒绝谣言。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqItems.map((item, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    isOpen
                      ? "border-primary-200 bg-background-100/70"
                      : "border-background-200 bg-background-50 hover:border-background-300"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  >
                    <span className="text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full transition-all ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200/80 text-foreground-700"
                      }`}
                    >
                      <i
                        className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-base`}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:px-6">
                        {item.a}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}